<template>
  <section>
    <back-button to="/"/>
    <h1>{{ $t('notFound.title') }}</h1>
    <panel>
      <p>{{ $t('notFound.description') }}</p>
      <p>{{ $t('notFound.confirmURL') }}</p>
      <enlil-button @click="onBackButtonClick">{{ $t('notFound.backToTop') }}</enlil-button>
    </panel>
  </section>
</template>

<script>
import BackButton from '../../components/BackButton.vue'
import EnlilButton from '../../components/EnlilButton.vue'
import Panel from '../../components/Panel.vue'

export default {
  name: 'not-found',
  components: {
    BackButton,
    EnlilButton,
    Panel
  },
  methods: {
    onBackButtonClick () {
      this.$router.push('/')
    }
  }
}
</script>
